import { apiService } from "../../common/api/apiService";
import { API_ENDPOINTS } from "../../common/api/apiEndpoints";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LOADING_STATUS } from "../../common/constants";
import { RootState } from "../../app/store";
/*
import {
  InitialPaginationResponse,
  PaginationParameters,
  PaginationResponse,
} from "../../types/pagination.types";

export interface FilterCriteria {
  showDeleted: boolean;
  searchString: string;
  accommodationNumber: number;
  novelty: boolean;
  showInWebShop: boolean;
  showInOwnerPage: boolean;
  accommodationGroupId: string;
  accountId: string;
}
 */
export interface AccommodationDetailsTranslations {
  id: string;
  keyId: string;
  locale: string;
  text: string;
  isDeleted: boolean;
}
export interface AccommodationGeoCode {
  latitude: number;
  longitude: number;
}

export interface AccommodationImage {
  fileName: string;
  fullUrl: string;
  thumbUrl?: string;
  carouselUrl?: string;
  grediFileId: string;
  index: number;
  modifiedDate: string;
  description: string;
  descriptionEn: string;
  descriptionRu: string;
  altText: string;
  id: string;
}

export interface AccommodationDetailsBasic {
  id: string;
  accommodationNumber: number;
  beds: number;
  extraBeds: number;
  novelty: boolean;
  translations: AccommodationDetailsTranslations[];
  internalQualityRating: number;
  showInWebShop: boolean;
  showInOwnerPage: boolean;
  qualityRating: number;
  notOnSaleDays: number;
  agentNumber: number;
  visibleOnFi: boolean;
  visibleOnEn: boolean;
  visibleOnRu: boolean;
  keyBox: string;
  countryId: string;
  regionId: string;
  municipalityId: string;
  skiResortId?: string;
  placeId?: string;
  commissionGroupId: string;
  //accommodationGroupData: AccommodationGroupData;
  addressId: string;
  fireSafety: boolean;
  optiWatti: boolean;
  leviItem: boolean;
  interhomeService: boolean;
  lastMinuteOffer: boolean;
  sportumId: string;
  geoCode: AccommodationGeoCode;
  useGredi: boolean;
  slug?: string;
  webStoreUrlFi?: string;
  webStoreUrlEn?: string;
}

export interface AccommodationChangeRequest {
  accommodationId: string;
  accommodationNumber: string;
  accommodationName: string;
  message: string;
  perusTiedot: boolean;
  varustelu: boolean;
  lisaPalvelut: boolean;
  kuvia: boolean;
  kuvaus: boolean;
  muutAsiat: boolean;
}

export interface UpdateAccommodationKeyBoxDto {
  accommodationId: string;
  keyBoxCode: string;
}

export interface UpdateAccommodationGeoCodeDto {
  accommodationId: string;
  geoCode: AccommodationGeoCode;
}

export interface AccommodationOptionValueItem {
  id: string;
  value: string;
}

export interface AccommodationDetailsAttributeOptionItem {
  id: string;
  nameFi: string;
  nameEn: string;
  nameRu: string;
}

export interface AccommodationAttributeItem {
  id?: string;
  intValue?: number;
  floatValue?: number;
  textValue: string;
  booleanValue?: boolean;
  optionValue?: AccommodationOptionValueItem[];
  index?: number;
  buildingRoomAreaId?: string;
  buildingRoomId?: string;
  buildingId?: string;
  multiSelectOptions?: AccommodationDetailsAttributeOptionItem[];
  attributeId?: string;
}

export interface AccommodationAttributeListItem {
  id: string;
  shortName: string;
  name: string;
  groupName: string;
  index: number;
  attributeType: {
    id: string;
    typeName: string;
    nameFi: string;
    nameEn: string;
    nameRu: string;
  };
}

export interface AccommodationAttributeQueryFilters {
  pageNumber: number;
  pageSize: number;
}

export interface AddOnValueDescriptionTranslations {
  id: string;
  keyId: string;
  locale: string;
  text: string;
  isDeleted: boolean;
}

export interface AccommodationAddonItem {
  id: string;
  ownerId: string;
  settlementReceiverId: string;
  price: number;
  addOnDefinitionId: number;
  purchasePrice: number;
  amountSingeCharge: boolean;
  amountPerQuantity: boolean;
  amountPerGuest: boolean;
  durationPerStay: boolean;
  durationPerNight: boolean;
  flatFee: boolean;
  percentage: boolean;
  ownerSingleChangePrice: boolean;
  descriptionTranslations: AddOnValueDescriptionTranslations[];
  isPrivate: boolean;
  isIncludedInPrice: boolean;
  name: string;
  sportumId: string;
  accommodationGroupId: string;
}

export interface AccommodationsState {
  accommodationDetailsBasic: AccommodationDetailsBasic;
  accommodationDetailsBasicLoadingStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
  accommodationImages: AccommodationImage[];
  accommodationImagesLoadingStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
  accommodationAttributes: AccommodationAttributeItem[];
  accommodationAttributesLoadingStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
  allAccommodationAttributesStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
  allAccommodationAttributeItems: AccommodationAttributeListItem[];
  accommodationAddons: AccommodationAddonItem[];
  accommodationAddonsLoadingStatus:
    | LOADING_STATUS.IDLE
    | LOADING_STATUS.LOADING
    | LOADING_STATUS.FAILED;
}
const initialState: AccommodationsState = {
  accommodationDetailsBasic: null,
  accommodationDetailsBasicLoadingStatus: LOADING_STATUS.IDLE,
  accommodationImages: [],
  accommodationImagesLoadingStatus: LOADING_STATUS.IDLE,
  accommodationAttributes: [],
  accommodationAttributesLoadingStatus: LOADING_STATUS.IDLE,
  allAccommodationAttributesStatus: LOADING_STATUS.IDLE,
  allAccommodationAttributeItems: [],
  accommodationAddons: [],
  accommodationAddonsLoadingStatus: LOADING_STATUS.IDLE,
};
/*
export interface AccommodationQueryFilters extends PaginationParameters {
  filterCriteria: FilterCriteria;
}
 */

export const getAccommodationDetailsBasicAsync = createAsyncThunk(
  "accommodation/getAccommodationDetailsBasic",
  async (id: string, { rejectWithValue }) => {
    const accommodationInfo = await apiService.get(
      API_ENDPOINTS.ACCOMMODATIONS.GET_ACCOMMODATION_DETAILS_BASIC +
        "?accommodationId=" +
        id,
    );
    return { accommodationInfo };
  },
);

export const getAccommodationAttributesAsync = createAsyncThunk(
  "accommodation/getAccommodationAttributes",
  async (id: string, { rejectWithValue }) => {
    const accommodationAttributes = await apiService.get(
      API_ENDPOINTS.ACCOMMODATIONS.GET_ACCOMMODATION_ATTRIBUTES +
        "?accommodationId=" +
        id,
    );
    return { accommodationAttributes };
  },
);

export const getAllAccommodationAttributesAsync = createAsyncThunk(
  "accommodation/getAllAccommodationAttributes",
  async (
    filterCriteria: AccommodationAttributeQueryFilters,
    { rejectWithValue },
  ) => {
    const accommodationAttributes = await apiService.post(
      API_ENDPOINTS.ACCOMMODATIONS.GET_ALL_ACCOMMODATION_ATTRIBUTES,
      filterCriteria,
    );
    return { accommodationAttributes };
  },
);

export const getAccommodationAddonsAsync = createAsyncThunk(
  "accommodation/getAccommodationAddons",
  async (id: string, { rejectWithValue }) => {
    const accommodationAddons = await apiService.get(
      API_ENDPOINTS.ACCOMMODATIONS.GET_ACCOMMODATION_ADDONS +
        "?accommodationId=" +
        id,
    );
    return { accommodationAddons };
  },
);

export const updateAccommodationKeyBoxAsync = createAsyncThunk(
  "accommodation/updateAccommodationKeyBoxAsync",
  async (
    updateAccommodationKeyBoxDto: UpdateAccommodationKeyBoxDto,
    { rejectWithValue },
  ) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.ACCOMMODATIONS.SET_ACCOMMODATION_KEYBOX,
        updateAccommodationKeyBoxDto,
      );
      return response.result;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const updateAccommodationGeoCodeAsync = createAsyncThunk(
  "accommodation/updateAccommodationKeyBoxAsync",
  async (
    updateAccommodationCoordinatesDto: UpdateAccommodationGeoCodeDto,
    { rejectWithValue },
  ) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.ACCOMMODATIONS.SET_ACCOMMODATION_GEOCODE,
        updateAccommodationCoordinatesDto,
      );
      return response.result;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const sendAccommodationChangeRequestAsync = createAsyncThunk(
  "accommodation/sendAccommodationChangeRequestAsync",
  async (
    accommodationChangeRequest: AccommodationChangeRequest,
    { rejectWithValue },
  ) => {
    try {
      const response = await apiService.post(
        API_ENDPOINTS.ACCOMMODATIONS.SEND_ACCOMMODATION_CHANGE_REQUEST,
        accommodationChangeRequest,
      );
      return response.result;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getAccommodationImagesAsync = createAsyncThunk(
  "accommodation/getAccommodationImages",
  async (id: string, { rejectWithValue }) => {
    const accommodationImages = await apiService.get(
      API_ENDPOINTS.ACCOMMODATIONS.GET_ACCOMMODATION_IMAGES +
        "?accommodationId=" +
        id,
    );
    return { accommodationImages };
  },
);

const accommodationSlice = createSlice({
  name: "accommodation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAccommodationDetailsBasicAsync.pending, (state) => {
        state.accommodationDetailsBasicLoadingStatus = LOADING_STATUS.LOADING;
      })
      .addCase(getAccommodationDetailsBasicAsync.fulfilled, (state, action) => {
        state.accommodationDetailsBasicLoadingStatus = LOADING_STATUS.IDLE;
        state.accommodationDetailsBasic =
          action.payload.accommodationInfo.result;
      })
      .addCase(getAccommodationDetailsBasicAsync.rejected, (state) => {
        state.accommodationDetailsBasicLoadingStatus = LOADING_STATUS.FAILED;
      })
      .addCase(getAccommodationImagesAsync.pending, (state) => {
        state.accommodationImagesLoadingStatus = LOADING_STATUS.LOADING;
      })
      .addCase(getAccommodationImagesAsync.fulfilled, (state, action) => {
        state.accommodationImagesLoadingStatus = LOADING_STATUS.IDLE;
        state.accommodationImages = action.payload.accommodationImages.result;
      })
      .addCase(getAccommodationImagesAsync.rejected, (state) => {
        state.accommodationImagesLoadingStatus = LOADING_STATUS.FAILED;
      })
      .addCase(getAccommodationAttributesAsync.pending, (state) => {
        state.accommodationAttributesLoadingStatus = LOADING_STATUS.LOADING;
      })
      .addCase(getAccommodationAttributesAsync.fulfilled, (state, action) => {
        state.accommodationAttributesLoadingStatus = LOADING_STATUS.IDLE;
        state.accommodationAttributes =
          action.payload.accommodationAttributes.result.accommodationAttributes;
      })
      .addCase(getAccommodationAttributesAsync.rejected, (state) => {
        state.accommodationAttributesLoadingStatus = LOADING_STATUS.FAILED;
      })
      .addCase(getAllAccommodationAttributesAsync.pending, (state) => {
        state.allAccommodationAttributesStatus = LOADING_STATUS.LOADING;
      })
      .addCase(
        getAllAccommodationAttributesAsync.fulfilled,
        (state, action) => {
          state.allAccommodationAttributesStatus = LOADING_STATUS.IDLE;

          state.allAccommodationAttributeItems =
            action.payload.accommodationAttributes.result;
        },
      )
      .addCase(getAllAccommodationAttributesAsync.rejected, (state) => {
        state.allAccommodationAttributesStatus = LOADING_STATUS.FAILED;
      })
      .addCase(getAccommodationAddonsAsync.pending, (state) => {
        state.accommodationAddonsLoadingStatus = LOADING_STATUS.LOADING;
      })
      .addCase(getAccommodationAddonsAsync.fulfilled, (state, action) => {
        state.accommodationAddonsLoadingStatus = LOADING_STATUS.IDLE;
        // console.log(action.payload.accommodationAddons.result.addOns);
        state.accommodationAddons =
          action.payload.accommodationAddons.result.addOns;
      })
      .addCase(getAccommodationAddonsAsync.rejected, (state) => {
        state.accommodationAddonsLoadingStatus = LOADING_STATUS.FAILED;
      });
  },
});

export const selectAccommodationDetailsBasic = (state: RootState) =>
  state.accommodation.accommodationDetailsBasic;

export const selectAccommodationDetailsBasicLoadingStatus = (
  state: RootState,
) => state.accommodation.accommodationDetailsBasicLoadingStatus;

export const selectAccommodationImages = (state: RootState) =>
  state.accommodation.accommodationImages;

export const selectAccommodationImagesLoadingStatus = (state: RootState) =>
  state.accommodation.accommodationImagesLoadingStatus;

export const selectAccommodationAttributes = (state: RootState) =>
  state.accommodation.accommodationAttributes;

export const selectAccommodationAttributesLoadingStatus = (state: RootState) =>
  state.accommodation.accommodationAttributesLoadingStatus;

export const selectAllAccommodationAttributes = (state: RootState) =>
  state.accommodation.allAccommodationAttributeItems;

export const selectAllAccommodationAttributesLoadingStatus = (
  state: RootState,
) => state.accommodation.allAccommodationAttributesStatus;

export const selectAccommodationAddons = (state: RootState) =>
  state.accommodation.accommodationAddons;

export const selectAccommodationAddonsLoadingStatus = (state: RootState) =>
  state.accommodation.accommodationAddonsLoadingStatus;

export default accommodationSlice.reducer;
